<article class="card-lembrete" [class]="'card-lembrete-' + situacao().classe">
  <div class="card-lembrete-topo">
    <img src="./assets/icones/redesign/modulos/lembretes/icon-signal-lembrete.svg" alt="" />
    <span class="card-lembrete-rotulo">Lembrete</span>
    <span class="card-lembrete-situacao">{{ situacao().texto }}</span>
  </div>

  <div class="card-lembrete-textos">
    <span class="card-lembrete-titulo" [title]="lembrete().titulo">{{ lembrete().titulo }}</span>
    <div class="card-lembrete-subtitulos">
      @if (template()) {
        <span class="card-lembrete-subtitulo card-lembrete-template" [title]="template()">Template de envio: {{ template() }}</span>
      } @else {
        <span class="card-lembrete-subtitulo">Sem template</span>
      }
      @if (lembrete().anotacao) {
        <span class="card-lembrete-subtitulo card-lembrete-anotacao" [title]="lembrete().anotacao">{{ lembrete().anotacao }}</span>
      } @else {
        <span class="card-lembrete-subtitulo">Sem anotação</span>
      }
    </div>
  </div>

  <span class="card-lembrete-data">
    <img src="./assets/icones/redesign/perfil-contato/lembrete-relogio.svg" alt="" />
    {{ lembrete().dataHora | date: 'dd/MM/yyyy' }} · {{ lembrete().dataHora | date: 'HH:mm' }}{{ lembrete().operadorNome ? ' - Criado por ' + lembrete().operadorNome : '' }}
  </span>
</article>
